import dndPromotion from "./promotion2.js";

// =============================================================================
// Nhạc nền: tạo thẻ <audio>, tự phát ở lần tương tác đầu, nút Âm Thanh (.sg1) bật/tắt.
// =============================================================================
$(window).on("load", function () {
	var musicUrl = $("#MS__wrapper").data("audio") || $("body").data("audio");
	if (!musicUrl) return;

	var $audio = $('<audio id="backgroundMusic" loop><source src="' + musicUrl + '" type="audio/mpeg"></audio>');
	$("body").append($audio);
	var audio = $audio.get(0);

	var hasInteracted = false;
	var $btnAmThanh = $(".sg1"); // 2 nút Âm Thanh (MS__state) bật/tắt nhạc

	var play = function () {
		audio.play().catch(function () {});
	};

	// Toggle khi bấm nút Âm Thanh.
	$btnAmThanh.on("click", function (e) {
		e.preventDefault();
		hasInteracted = true;
		audio.paused ? play() : audio.pause();
	});

	// Tự phát ở lần tương tác đầu tiên trên trang.
	$(document).one("click touchstart", function () {
		if (hasInteracted) return;
		hasInteracted = true;
		play();
	});

	// Rời tab thì tạm dừng, quay lại thì phát tiếp (nếu user đã từng bật).
	document.addEventListener("visibilitychange", function () {
		if (document.hidden) audio.pause();
		else if (hasInteracted) play();
	});
});

$(window).on("load", function () {
	var $communityToggle = $(".js-community-toggle");
	var $communityDropdown = $(".community-dropdown");

	$communityToggle.on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();
		$communityDropdown.toggleClass("is-open");
	});

	$communityDropdown.on("click", function (e) {
		e.stopPropagation();
	});

	$(document).on("click", function () {
		$communityDropdown.removeClass("is-open");
	});
});

// =============================================================================
// CỜ TỶ PHÚ — port nguyên từ platformPromotion/cotyphu (index.js):
// dndPromotion lo get_data/save_data, Animation lo lắc xúc xắc + nhảy ô.
// =============================================================================

// Promise-based wait để xâu chuỗi từng bước (await được).
class Core {
	constructor() {
		this.currentTimeout = null;
	}
	wait(timeout) {
		if (this.currentTimeout) clearTimeout(this.currentTimeout);
		return new Promise((resolve) => {
			this.currentTimeout = setTimeout(resolve, timeout);
		});
	}
}

// Quân cờ = .nhanvat (nhảy ô→ô trên .board .cell), xúc xắc = .xucxac.
// Bàn cờ hiện có 16 ô, đi theo đúng thứ tự DOM (vòng kim đồng hồ).
class Animation {
	constructor() {
		this.$frame = $("#Frame1");
		this.$cells = this.$frame.find(".board .cell");
		this.$dice = this.$frame.find(".xucxac");
		this.$result = this.$frame.find(".result");
		this.$nv = this.$frame.find(".nhanvat");
		this.core = new Core();
		this.STEP = 320; // ms mỗi bước nhảy (đồng bộ transition CSS)
	}

	// Số ô trên bàn (an toàn nếu rỗng).
	get len() {
		return this.$cells.length || 1;
	}

	// Toạ độ đích để quân cờ đứng giữa ô index (0-based).
	// Dùng offsetLeft/Top (layout GỐC, không bị scale transform của wrapper),
	// KHÔNG dùng .position() (trả toạ độ đã scale → lệch với .css(left/top)).
	targetOf(index) {
		const cell = this.$cells.get(index);
		const nv = this.$nv.get(0);
		if (!cell || !nv) return null;
		return {
			left: cell.offsetLeft + (cell.offsetWidth - nv.offsetWidth) / 2,
			top: cell.offsetTop + (cell.offsetHeight - nv.offsetHeight) / 2 - 10,
		};
	}

	// Đặt quân cờ lên ô index (0-based) + nhịp nhảy.
	moveTo(index) {
		const t = this.targetOf(index);
		if (!t) return;
		this.$nv.css({ left: t.left + "px", top: t.top + "px" });
		this.$nv.removeClass("cotyphu-jump");
		void this.$nv[0].offsetWidth; // reflow để restart keyframe
		this.$nv.addClass("cotyphu-jump");
	}

	// Đặt quân cờ vào ô xuất phát lúc tải trang (không nhảy).
	place(currentPosition) {
		const start = (((currentPosition - 1) % this.len) + this.len) % this.len;
		const t = this.targetOf(start);
		if (t) this.$nv.css({ left: t.left + "px", top: t.top + "px" });
	}

	// Mở màn: lắc xúc xắc tại chỗ → flash mặt số vừa đổ (result-1..6) rồi ẩn.
	// random = quẻ 1..6 (cũng là số bước tiến) → hiện .face-{random}.
	async firstEffect(startIndex, random) {
		this.$dice.addClass("rolling");
		this.moveTo(startIndex);
		await this.core.wait(1200);
		this.$dice.removeClass("rolling");

		// Hiện mặt số vừa đổ giữa bàn cờ (overlay dim + card pop), giữ ~1.3s rồi ẩn.
		this.$result.find(".face").removeClass("is-on");
		this.$result.find(".face-" + random).addClass("is-on");
		this.$result.addClass("active");
		await this.core.wait(1300);
		this.$result.removeClass("active");
		await this.core.wait(400);
	}

	// Nhảy TIẾN amount bước (wrap vòng tại ô cuối). Trả index cuối (0-based).
	async steppingUp(fromIndex, amount) {
		const max = this.len - 1;
		let idx = fromIndex;
		for (let i = 0; i < amount; i++) {
			idx = idx + 1 > max ? 0 : idx + 1;
			this.moveTo(idx);
			await this.core.wait(this.STEP);
		}
		return idx;
	}

	// Nhảy LÙI amount bước (wrap vòng tại ô đầu). Trả index cuối (0-based).
	async steppingDown(fromIndex, amount) {
		const max = this.len - 1;
		let idx = fromIndex;
		for (let i = 0; i < amount; i++) {
			idx = idx - 1 < 0 ? max : idx - 1;
			this.moveTo(idx);
			await this.core.wait(this.STEP);
		}
		return idx;
	}

	// Chuỗi 1 lượt: lắc xúc xắc → tiến random → (lùi back) → (tiến forward).
	async run(currentPosition, random, back, forward) {
		const start = (((currentPosition - 1) % this.len) + this.len) % this.len;
		await this.firstEffect(start, random);
		let idx = await this.steppingUp(start, random);
		if (back > 0) idx = await this.steppingDown(idx, back);
		if (forward > 0) idx = await this.steppingUp(idx, forward);
		return idx;
	}
}

$(window).on("load", function () {
	const animation = new Animation();
	const startPos = parseInt(currentPosition, 10) || 1;
	if (animation.$cells.length) animation.place(startPos);

	dndPromotion({
		url: prodTemplate.url,
		debug: prodTemplate.debug,
		directory: prodTemplate.directory,
		items: prodTemplate.items,
		names: prodTemplate.names,
		startPosition: currentPosition,
		config: { timeWait: 0 },
		animResult: async function (listPrize) {
			const { currentPosition, random, back, forward } = listPrize[0];
			var rewardPopup = listPrize.rewardPopup || listPrize[0].rewardPopup || "#popup_reward";
			var $rewardPopup = $(rewardPopup);

			// Banner đổi theo quẻ trúng: oso{n}_qua → oso{n}_anh.jpg
			var imgId = listPrize[0].indexImg;
			if (imgId) {
				$rewardPopup.find(".banner").attr(
					"src",
					prodTemplate.directory + "/" + imgId.replace("_qua", "_anh") + ".jpg"
				);
			}

			// Cập nhật reward-block từ namesCustom.text1 / text2
			var key = listPrize[0].indexWord;
			var nc = prodTemplate.namesCustom || {};
			if (nc.text1 && nc.text1[key]) {
				$rewardPopup.find(".reward-label").text(nc.text1[key]);
			}
			if (nc.text2 && nc.text2[key]) {
				$rewardPopup.find(".reward-text").text(nc.text2[key]);
			}

			await animation.run(currentPosition, random, back, forward);
			await new Core().wait(500);
		},
		callback: function () {
			if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();
		},
	});
});
